
import { Vue, Prop, Component } from 'vue-property-decorator';
import { eInputType } from '@/interface/exchange-code';
import { eEndPoint } from '@/interface/hot-game';

@Component
export default class ExchangePop extends Vue {
  @Prop() text!: any;
  @Prop() titleValue!: string;
  @Prop() fillText1!: string;
  @Prop() route_type!: number;
  eInputType: any = eInputType;
  android: eEndPoint = eEndPoint.ADNROID;
  web: eEndPoint = eEndPoint.WEB;
  mounted() {}
}
